import AppSettings from 'arc4u.framework.js/token/AppSettings';


export function goToPrequalification() {
    let urlSettings =  AppSettings.Get("OAuth").Values.filter(v => v.Key === "PrFileSubmissionWebAppUrl")
    if(urlSettings.length > 0) window.location.href = urlSettings[0].Value
}

export function goToAuction() {
    let urlSettings =  AppSettings.Get("OAuth").Values.filter(v => v.Key === "AuctionWebAppUrl")
    if(urlSettings.length > 0) window.location.href = urlSettings[0].Value
}

export function goToFinancialSecurity() {
    let urlSettings =  AppSettings.Get("OAuth").Values.filter(v => v.Key === "FinancialSecurityWebAppUrl")
    if(urlSettings.length > 0) window.location.href = urlSettings[0].Value
}

export function goToSecondaryMarket() {
    let urlSettings =  AppSettings.Get("OAuth").Values.filter(v => v.Key === "SecondaryMarketWebAppUrl")
    if(urlSettings.length > 0) window.location.href = urlSettings[0].Value
}

export function goToPDM() {
    let urlSettings =  AppSettings.Get("OAuth").Values.filter(v => v.Key === "PDMWebAppUrl")
    if(urlSettings.length > 0) window.location.href = urlSettings[0].Value
}

export function goToAvMonitoring() {
    let urlSettings =  AppSettings.Get("OAuth").Values.filter(v => v.Key === "AvailabilityMonitoringWebAppUrl")
    if(urlSettings.length > 0) window.location.href = urlSettings[0].Value
}

export function goToSettlement() {
    let urlSettings =  AppSettings.Get("OAuth").Values.filter(v => v.Key === "SettlementWebAppUrl")
    if(urlSettings.length > 0) window.location.href = urlSettings[0].Value
}